export const getPersonRecordKey = (record: any): any => (record?.dcPersonId ? record?.dcPersonId : record?.personId);
